import ApiUtil from "@/api/api.util"
import ApiConfig from "@/api/api.config"
import EtnersCommonUtil from '@/common/etners.common.util'
import EtnersParseUtil from '@/common/etners.parse.util'

/**
 * 회사관리 - 회사 상세정보 자료 조회
 * @param param
 * @returns {Promise<any>}
 */
const getCompanyInfo = function (param) {

  return new Promise(resolve => {

    ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/company/detail.json`, param)
    .then(response => {

      if (response.data === undefined || response.data.resultStatus === undefined) {
        kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
        resolve(false)
      }
      if (response.data.resultStatus.messageCode !== '2000') {
        kendo.alert(response.data.resultStatus.messageText)
        resolve(false)
      }

      let companyInfoResponse = response.data.resultData

      // 공통코드 처리
      let commonCodeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()

      if(companyInfoResponse !== null) {

        // converting code to text (구분, 업종)
        companyInfoResponse.cvtCmpyGbn = EtnersParseUtil.commonCodeToText(commonCodeMap, companyInfoResponse.cmpyGbn)
        companyInfoResponse.cvtBizType = EtnersParseUtil.commonCodeToText(commonCodeMap, companyInfoResponse.bizType)

        // 솔루션목록 Grid row 번호
        let rowNumber = 0
        for (let i = 0; i < companyInfoResponse.companySolutionList.length; i++) {
          let row = companyInfoResponse.companySolutionList[i]
          // row 번호 셋팅
          row.rowNumber = ++rowNumber

          // converting code to text (구분)
          row.cvtWmGbn = EtnersParseUtil.commonCodeToText(commonCodeMap, row.wmGbn)
        }
      }

      resolve(companyInfoResponse)
    })
    .catch(error => {
      console.log(error)
    })
  })
}

/**
 * 조직도관리 > 부서관리 - 부서 트리목록 자료 조회
 * @param param
 */
const getDeptTreeList = function (cmpyCd) {

  return new Promise(resolve => {

    const param = {
      loginUserToken: sessionStorage.lutk,
      cmpyCd: cmpyCd,
      displayRootYn: 'Y',
      displayUserYn: 'N'
    }
    // vm.$Progress.start()
    ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/dept/organizationChartTreeDeptForKendo.json`, param)
    .then(response => {

      if(response.data.resultData === undefined || response.data.resultData === null) {
        // vm.$Progress.fail()
        resolve(false)
      }
      if(response.data.resultStatus.messageCode !== '2000') {
        // vm.$Progress.fail()
        resolve(false)
      }

      /*let complexDeptTreeList = []
      complexDeptTreeList.push(this.makeComplexDeptTreeListWithAddButton(response.data.resultData))*/
      let complexDeptTreeList = response.data.resultData

      resolve(complexDeptTreeList)

      /*vm.complexLocalDataSource.push(vm.makeComplexLocalDataSourceWithAddButton(response.data.resultData))
      vm.keyObjectLocalDataSource = vm.convertTreeToKeyObject(response.data.resultData)

      if(vm.complexLocalDataSource[0].items === null) {
        vm.booleanShowExcelUpload = true
      }

      vm.$Progress.finish()*/
    })
    .catch(error => {
      console.log(error)
    })
  })
}

/**
 * 조직도관리 > 부서관리 - 부서 tree 리스트 데이터에 부서추가 버튼 추가하여 리턴
 * @param root
 * @returns {*}
 */
const makeComplexDeptTreeListWithAddButton = function (root) {
  let stack = []

  stack.push(root)

  while(stack.length !== 0) {
    let node = stack.pop()

    if(node.items !== null && node.items !== undefined) {
        node.items.push({
          'superDeptCd': node.deptCd,
          'superDeptNm': node.deptNm,
          'deptCd': 'NEW',
          'deptNm': '부서 추가',
        })

        for(let i=node.items.length-1; i>=0; i--) {
          if(node.items[i].deptCd !== 'NEW') {
            stack.push(node.items[i])
          }
        }
    } else {
      node.items = [{
        'superDeptCd': node.deptCd,
        'superDeptNm': node.deptNm,
        'deptCd': 'NEW',
        'deptNm': '부서 추가',
      }]
    }
  }

  return root
}


export default {
  getCompanyInfo,
  getDeptTreeList,
  makeComplexDeptTreeListWithAddButton
}
